import React, { FC, useCallback, useRef } from "react";
import { Button, Divider, message, Tooltip } from "antd";

import { Card, CardBody, Typography } from "../material-old";
import { useAppDispatch, useAppSelector } from "../../redux/hooks.ts";
import { DateFilter } from "./DateFilter.tsx";
import {
  CloseOutlined,
  FolderAddFilled,
  UserOutlined,
} from "@ant-design/icons";
import { FilterSortDropdown } from "./FilterSortDropdown.tsx";
import { AssignedUserFilter } from "./AssignedUserFilter.tsx";
import { setFilterUser } from "../../redux/slices/folderSlice.ts";
import { CreateRecordModal } from "./CreateRecordModal/index.tsx";

export const Header: FC = () => {
  const dispatch = useAppDispatch();
  const formRef = useRef<any>(null);
  const [_, contextHolder] = message.useMessage();
  const { results, filterUser } = useAppSelector((state) => state.folder);
  const { userInfo } = useAppSelector((state) => state.auth);
  const isAdmin: boolean | undefined = userInfo?.groups.includes("admin");
  const isAssistant: boolean | undefined =
    userInfo?.groups.includes("assistant");
  const [isUserFilter, setIsUserFilter] = React.useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = React.useState(false);

  const onCreateRecord = () => {
    setIsCreateModalOpen(true);
  };

  const onCloseFilterByUser = useCallback(() => {
    setIsUserFilter(false);
  }, []);

  return (
    <>
      <Card className={`w-full mx-auto`}>
        {contextHolder}
        <CardBody className="flex flex-col justify-center items-center">
          <div className="w-full flex justify-between items-center">
            <div className="w-2/3 flex flex-col items-start">
              <Typography variant="h4" color="blue-gray" className="mb-1">
                Expedientes
              </Typography>
              <div className="text-gray-600">
                En esta sección podrás visualizar y gestionar todos los
                expedientes de inquilinos del sistema.
              </div>
            </div>
            <div style={{ fontSize: "0.925rem" }}>
              <Button
                type="primary"
                size="large"
                onClick={onCreateRecord}
                icon={<FolderAddFilled />}
                className="px-4 py-2"
              >
                <span>Crear expediente</span>
              </Button>
            </div>
          </div>

          <Divider orientation="left"></Divider>

          <div className="flex flex-wrap items-center w-full gap-3 justify-center">
            <div className="flex-shrink-0">
              <div className="relative group">
                <DateFilter />
              </div>
            </div>

            {(isAdmin || isAssistant) && (
              <div className="flex-shrink-0">
                <div className="relative">
                  <Button
                    type="default"
                    key="user"
                    icon={<UserOutlined className="text-emerald-600" />}
                    onClick={() => setIsUserFilter(true)}
                    className="group relative overflow-hidden border-emerald-200 hover:border-emerald-400"
                  >
                    <div className="flex items-center gap-2 min-w-0">
                      <span className="text-sm max-w-[120px] truncate text-gray-700 hover:text-emerald-700">
                        {filterUser?.email
                          ? filterUser?.email
                          : "Usuario asignado"}
                      </span>
                      {filterUser?.email && (
                        <Tooltip title="Quitar filtro" placement="top">
                          <div
                            className="flex items-center justify-center w-5 h-5"
                            onClick={(e) => {
                              e.stopPropagation();
                              dispatch(setFilterUser({ email: "", group: "" }));
                              if (formRef.current) {
                                formRef.current.resetUserFilter();
                              }
                            }}
                          >
                            <CloseOutlined className="text-xs" />
                          </div>
                        </Tooltip>
                      )}
                    </div>
                  </Button>
                  {filterUser?.email && (
                    <div className="absolute -top-1 -right-1 w-3 h-3 bg-emerald-500 rounded-full animate-pulse"></div>
                  )}
                </div>
              </div>
            )}
            <div>
              <FilterSortDropdown
                type="filter"
                isMyFoldersView={false}
                includeSpecialFilters
              />
            </div>
            <div>
              <FilterSortDropdown type="filter" isMyFoldersView={false} />
            </div>
            <div>
              <FilterSortDropdown type="sort" isMyFoldersView={false} />
            </div>
          </div>
          <Divider orientation="left"></Divider>
          <div className="w-full flex text-sm">
            <span className="ml-auto">
              Expedientes encontrados: <b>{results.length}</b>
            </span>
          </div>
        </CardBody>
      </Card>
      <AssignedUserFilter
        ref={formRef}
        open={isUserFilter}
        onClose={onCloseFilterByUser}
      />
      <CreateRecordModal
        isOpen={isCreateModalOpen}
        onOpenChange={setIsCreateModalOpen}
      />
    </>
  );
};
